import Modal from "../../core/components/Modal/Modal";
import LimitsConfigurator from "./LimitsConfigurator";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LimitsModal(_ref) {
  let {
    configurator,
    isOpen = false
  } = _ref;
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onRequestClose: configurator.onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "LimitsModal",
    "data-sentry-source-file": "LimitsModal.tsx",
    children: /*#__PURE__*/_jsx(LimitsConfigurator, {
      ...configurator,
      "data-sentry-element": "LimitsConfigurator",
      "data-sentry-source-file": "LimitsModal.tsx",
      "data-sentry-element": "LimitsConfigurator"
    })
  });
}